import React from "react";
import { Star } from "lucide-react";

export default function TestimonialCard({ name, text, rating = 5, tourName, createdAt }) {
  const initials = (name || "A")
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);

  const timeAgo = createdAt
    ? (() => {
        const diff = Date.now() - new Date(createdAt).getTime();
        const days = Math.floor(diff / 86400000);
        if (days === 0) return "Today";
        if (days === 1) return "Yesterday";
        if (days < 30) return `${days} days ago`;
        if (days < 365)
          return `${Math.floor(days / 30)} month${Math.floor(days / 30) > 1 ? "s" : ""} ago`;
        return new Date(createdAt).toLocaleDateString();
      })()
    : null;

  return (
    <div className="group relative rounded-xl border border-slate-200 bg-white p-5 shadow-sm transition-all hover:shadow-md hover:-translate-y-0.5 dark:border-slate-800 dark:bg-slate-900">
      {/* Quote icon */}
      <svg
        className="absolute top-4 right-4 h-8 w-8 text-emerald-100 dark:text-emerald-900/40 transition-colors group-hover:text-emerald-200 dark:group-hover:text-emerald-800/40"
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10H14.017zM0 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151C7.546 6.068 5.983 8.789 5.983 11H10v10H0z" />
      </svg>

      {/* Stars */}
      <div className="flex gap-0.5 mb-4">
        {[1, 2, 3, 4, 5].map((s) => (
          <Star
            key={s}
            size={16}
            className={
              s <= Math.round(rating)
                ? "text-yellow-400 fill-yellow-400"
                : "text-slate-300 dark:text-slate-600"
            }
          />
        ))}
      </div>

      {/* Review text */}
      <p className="text-sm text-slate-600 dark:text-slate-300 leading-relaxed mb-4 line-clamp-3">
        {text ? `"${text}"` : "Great experience!"}
      </p>

      {/* Author */}
      <div className="flex items-center gap-3 pt-3 border-t border-slate-100 dark:border-slate-800">
        <div className="flex-shrink-0 h-10 w-10 rounded-full bg-gradient-to-br from-emerald-500 to-teal-600 flex items-center justify-center text-white text-sm font-bold shadow-sm">
          {initials}
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-semibold text-sm text-slate-900 dark:text-slate-100 truncate">
            {name}
          </p>
          <div className="flex items-center gap-1.5 text-xs text-slate-500 dark:text-slate-400">
            {tourName && (
              <>
                <span className="truncate">{tourName}</span>
                {timeAgo && <span>·</span>}
              </>
            )}
            {timeAgo && <span className="whitespace-nowrap">{timeAgo}</span>}
          </div>
        </div>
      </div>
    </div>
  );
}
